import React, { useState, useEffect } from "react";

import * as XLSX from "xlsx";
import { format } from "date-fns";

import utility from "@app/lib/utility";

const ExcelDownloadBtn = ({ view, statPeriod }) => {
    const [isWorking, setWorkingStatus] = useState(false);
    useEffect(() => {
        return () => {};
    }, [view, statPeriod]);

    const onDownload = () => {
        const excelHandler = {
            getExcelPeriod: () => {
                let text = "";
                if (statPeriod) {
                    if (statPeriod.type === "month") {
                        text = format(new Date(statPeriod.startDate), "yyyy년 MM월");
                    } else if (statPeriod.type === "year") {
                        text = format(new Date(statPeriod.startDate), "yyyy학년도");
                    } else {
                        text = `${statPeriod.startDate} ~ ${statPeriod.endDate}`;
                    }
                }
                return text;
            },
            getFileName: (_fileName) => {
                let fileName = _fileName + "_" + format(new Date(), "yyyyMMddHHmmss") + ".xlsx";
                return fileName;
            },
        };

        if (view && view.current) {
            setWorkingStatus(true);
            view.current.getExcelData((err, excelData) => {
                if (err) {
                    console.error(err);
                } else {
                    if (statPeriod && excelData) {
                        var wb = XLSX.utils.book_new();
                        excelData.sheets.forEach((s) => {
                            let rowNumber = 1;
                            var ws = XLSX.utils.aoa_to_sheet([]);
                            XLSX.utils.sheet_add_aoa(ws, [["기간", excelHandler.getExcelPeriod()]], { origin: { r: rowNumber++, c: 0 } });
                            XLSX.utils.sheet_add_aoa(ws, [["통계", s.title]], { origin: { r: rowNumber++, c: 0 } });
                            rowNumber++;
                            rowNumber++;
                            if (s.columnTitle) {
                                if (Array.isArray(s.columnTitle)) {
                                    if (s.columnTitle) {
                                        XLSX.utils.sheet_add_aoa(ws, [s.columnTitle], { origin: { r: rowNumber++, c: 0 } });
                                    }
                                    XLSX.utils.sheet_add_json(ws, s.data, { header: s.header, origin: { r: rowNumber++, c: 0 }, skipHeader: true });
                                } else {
                                    if (s.columnTitle.merges) {
                                        ws["!merges"] = s.columnTitle.merges.map((m) => {
                                            return { s: { r: m.s.r + rowNumber, c: m.s.c }, e: { r: m.e.r + rowNumber, c: m.e.c } };
                                        });
                                    }
                                    s.columnTitle.rows.forEach((r) => {
                                        XLSX.utils.sheet_add_aoa(ws, [r.title], { origin: { r: rowNumber++, c: r.originColumn } });
                                    });
                                    XLSX.utils.sheet_add_json(ws, s.data, { origin: { r: rowNumber++, c: 0 }, skipHeader: true });
                                }
                            } else {
                                XLSX.utils.sheet_add_json(ws, s.data, { header: s.header, origin: { r: rowNumber++, c: 0 }, skipHeader: true });
                            }
                            XLSX.utils.book_append_sheet(wb, ws, s.name);
                        });

                        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
                        utility.download2Excel(wbout, excelHandler.getFileName(excelData.fileName));
                    }
                }
            });
            setWorkingStatus(false);
        }
    };

    return (
        <div className="mr-3" style={{ flex: 1 }}>
            <button type="button" className="btn btn-sm btn-outline-secondary float-right" style={{ minWidth: "95px" }} onClick={onDownload} disabled={isWorking}>
                {isWorking && <span className="fa fa-spinner" style={{ animation: "1s spin linear infinite" }}></span>}
                {!isWorking && (
                    <span>
                        <i className="fas fa-table mr-1"></i>다운로드
                    </span>
                )}
            </button>
        </div>
    );
};

export default ExcelDownloadBtn;
